export const messages = {
  onDelete: 'Успешно удалено!',
  onSave: 'Успешно сохранено!',
  selectMkoBeforeCreateCard: 'Чтобы добавить карту пожалуйста веберите МКО!',
  onAddedCard: 'Карта успешно добавлено!',
  onRejectedCredit: 'Кредит успешно отменено!',
  onConfirmedCredit: 'Кредит успешно активировано!',
  sendNotification: 'Сообщение отправлено!',
  onCloseCredit: 'Кредит успешно закрылся!',
  successTransfer (amount) {
    let message = "{amount} успешно принять"
    return message.replace("{amount}", amount)
  }
}


export const GENDERS = [
  {
    text: 'Мужчина',
    value: 1
  },
  {
    text: 'Женщина',
    value: 0
  }
]

export const PAYMENT_TYPES = [
  {
    text: 'Нал.',
    value: 'cash'
  },
  {
    text: 'Пластик',
    value: 'card'
  },
  {
    text: 'Терминал',
    value: 'terminal'
  },
  {
    text: 'Автопогашения',
    value: 'auto'
  }

]

export const CREDIT_PAYMENT_TYPES = [
  {
    text: 'Наличные',
    value: 'cash'
  },
  {
    text: 'Пластик',
    value: 'card'
  },
  {
    text: 'Терминал',
    value: 'terminal'
  },
]

export const PAYMENT_TYPES_INDEX_VALUE = PAYMENT_TYPES.reduce((obj,item) => {
  obj[item.value] = item
  return obj
}, {})

export const TARIFF_TYPES = [
  {
    text: 'annuity',
    value: 'annuity'
  },
  {
    text: 'differential',
    value: 'differential'
  }
]

export const CREDIT_STATUS = [
  {
    text: 'Ждет подтверждения',
    value: 3,
    slug: 'created'
  },
  {
    text: 'Активно',
    value: 2,
    slug: 'activated'
  },
  {
    text: 'Закрыто',
    value: 5,
    slug: 'done'
  },
  {
    text: 'Отменено',
    value: 0,
    slug: 'cancelled'
  },
]

export const TRANSACTIONS_STATUS = [
  {
    text: 'Успешно',
    value: 10
  },
  {
    text: 'Ошибка',
    value: 0
  },
  {
    text: 'Создан',
    value: 1
  },
]

export const DEBT_STATUS = [
  {
    text: 'К оплате в ближайшие 3 дня',
    value: 1
  },
  {
    text: 'Просроченные до 10 дней',
    value: 2
  },
  {
    text: 'Просроченные до 1 месяца',
    value: 3
  },
  {
    text: 'Просроченные более 1 месяца',
    value: 4
  }
]

export const CREDIT_STATUS_INDEX = CREDIT_STATUS.reduce((obj, item) => {
  obj[item.slug] = item
  return obj
}, {})

export const GRAPH_STATUS = [
  {
    text: 'не оплачено',
    color: 'warning',
    value: 0
  },
  {
    text: 'в процесе',
    color: 'secondary',
    value: 1
  },
  {
    text: 'просрочено',
    color: 'error',
    value: 5
  },
  {
    text: 'оплачено',
    color: 'primary',
    value: 10
  }
]

export const parsePhone = number => {
  return {
    format(format) {
      if (format === 'min') {
        return number.split(/^(\+?998)/).pop()
      } else if (format === 'max') {
        return '+998' + number.replace('-', '')
      }
    }
  }
}

export const TRANSACTION_STATUS = [
  {
    text: 'отказано',
    color: 'error',
    value: 0
  },
  {
    text: 'успешно',
    color: 'primary',
    value: 10
  }
]

export const AUTO_PAYMENT = {
  yes: 'Да',
  no: 'Нет',
}
export const DATE_FORMAT = 'YYYY-MM-DD'

export const defaultDialogWidth = 600

export const phoneMask = () => {
  return '###-##-###-##-##'
}

export const THEMES = {
  dark: 'Ночь',
  light: 'День'
}

export const TIME_OUT_REFRESH_TOKEN = 60*20


export const GET_PERCENTS = () => {
  const percents = new Array(10)
  percents.fill(0, 0, percents.length)
  return percents.map((item, index) => {
    const percent = (index+ 1) * 10
    return {
      text:  percent + '%',
      value: `${percent}`
    }
  })
}

export const ROLES = {
  superAdmin: 'superAdmin',
  inspector: 'inspector',
  mko: 'mko',
  user: 'user'
}
